module.exports = __webpack_public_path__ + "static/media/deal-marker.a5e1ca02.svg";